import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { ListLabelsMacroRendererProps } from '../src/ListLabelsMacroRenderer.tsx';

export const ListLabelsMacroHandler: LoadableType<ListLabelsMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ListLabelsMacro" */ '../src/ListLabelsMacroRenderer.tsx'
			)
		).ListLabelsMacroRenderer,
});
